import { render } from "./TeleOperation.vue?vue&type=template&id=1f967146"
import script from "./TeleOperation.vue?vue&type=script&lang=js"
export * from "./TeleOperation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__